<script>
	import Time from 'svelte-time';
	import { storeSettings } from '../../store/StoreSettings';
	import { get } from 'svelte/store';

	export let event = {};

	const settings = get(storeSettings);

	const eventUrl = settings.eventUrl.replace(':eventCode', event.code);
</script>

<div class="py-4 h-full">
	<div
		class=" block overflow-hidden shadow-lg h-full {settings.darkMode ? 'bg-gray-900' : 'bg-white'}"
		class:rounded-lg={settings.borderRadius}
	>
		<div class="relative">
			<img class="w-full" src={event.image} alt={event.name} />
			<div
				class="hover:bg-transparent transition duration-300 absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25"
			/>
		</div>

		<div class="px-6 py-4 {settings.darkMode ? 'text-white' : 'text-black'}">
			<!-- <h4 class="text-user-primary font-semibold uppercase text-sm">
				{event.category.name}
			</h4> -->
			<h2 class="font-semibold text-lg inline-block transition duration-500 ease-in-out">
				{event.name}
			</h2>
			<h3 class="font-light opacity-60 text-sm mt-1">
				<Time timestamp={event.startAt} format="ddd DD [de] MMM" />
				| <Time timestamp={event.startAt} format="HH:mm" /> - <Time
					timestamp={event.endAt}
					format="HH:mm"
				/>
			</h3>
			<div class="flex opacity-60 mt-2 text-sm">
				<svg
					data-v-187cba36=""
					data-v-55f0248f=""
					data-v-005bfc5a=""
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					stroke-width="2"
					stroke="currentColor"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					class="icon icon-tabler icon-tabler-map-pin w-5 h-5 opacity-50 mr-1 "
					><path
						data-v-187cba36=""
						data-v-55f0248f=""
						data-v-005bfc5a=""
						stroke="none"
						d="M0 0h24v24H0z"
						fill="none"
					/><circle
						data-v-187cba36=""
						data-v-55f0248f=""
						data-v-005bfc5a=""
						cx="12"
						cy="11"
						r="3"
					/><path
						data-v-187cba36=""
						data-v-55f0248f=""
						data-v-005bfc5a=""
						d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
					/></svg
				>
				{event.location.name}
			</div>
			<!-- <div class="flex opacity-60 mt-2 text-sm">
				<svg
					data-v-187cba36=""
					data-v-55f0248f=""
					data-v-005bfc5a=""
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					stroke-width="2"
					stroke="currentColor"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					class="icon icon-tabler icon-tabler-coin w-5 h-5 opacity-50 mr-1 ml-2"
					><path
						data-v-187cba36=""
						data-v-55f0248f=""
						data-v-005bfc5a=""
						stroke="none"
						d="M0 0h24v24H0z"
						fill="none"
					/><circle
						data-v-187cba36=""
						data-v-55f0248f=""
						data-v-005bfc5a=""
						cx="12"
						cy="12"
						r="9"
					/><path
						data-v-187cba36=""
						data-v-55f0248f=""
						data-v-005bfc5a=""
						d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-2a2 2 0 0 1 -1.8 -1"
					/><path data-v-187cba36="" data-v-55f0248f="" data-v-005bfc5a="" d="M12 6v2m0 8v2" /></svg
				>
				{event.pricesRange}
			</div> -->
		</div>
	</div>
</div>

<style>
</style>
